import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const SuccessOutlineSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "8 7 66.8 66.8",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M41.4438 73.5677C59.6806 73.5677 74.7917 58.4791 74.7917 40.2344C74.7917 21.9897 59.6516 6.90103 41.4148 6.90103C23.194 6.90103 8.125 21.9897 8.125 40.2344C8.125 58.4791 23.223 73.5677 41.4438 73.5677ZM41.4438 68.6585C25.7186 68.6585 13.0771 55.9955 13.0771 40.2344C13.0771 24.4733 25.6896 11.8102 41.4148 11.8102C57.169 11.8102 69.8556 24.4733 69.8556 40.2344C69.8556 55.9955 57.1981 68.6585 41.4438 68.6585ZM37.8656 55.8886C38.8115 55.8886 39.6023 55.4298 40.203 54.5516L55.7418 30.1593C56.0741 29.5975 56.4195 28.9385 56.4195 28.3056C56.4195 27.0267 55.2863 26.1704 54.053 26.1704C53.3073 26.1704 52.5774 26.6131 52.0188 27.4753L37.7364 50.258L30.68 41.3483C29.9763 40.4279 29.3306 40.1855 28.5297 40.1855C27.2804 40.1855 26.2794 41.19 26.2794 42.4949C26.2794 43.1249 26.5506 43.7549 26.951 44.3137L35.383 54.5516C36.1288 55.5009 36.8775 55.8886 37.8656 55.8886Z"
        fill={color}
      />
    </svg>
  );
};

export { SuccessOutlineSvg };
